module.exports = __webpack_public_path__ + "files/03cdef169bc41fab4cb64b81fe1d6a8e.png";